import { render, staticRenderFns } from "./fr4Form.vue?vue&type=template&id=4f04b4a6&scoped=true"
import script from "./fr4Form.vue?vue&type=script&lang=js"
export * from "./fr4Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f04b4a6",
  null
  
)

export default component.exports